<template>
  <!-- BackStage Logo 先用 -->
  <div id="header">
    <!-- ▼LOGO圖片 -->
    <h1>
      <a :href="LogoUrl"><img :src="Logo" class="logo" /></a>
    </h1>
    <!-- ▲LOGO圖片-->

    <ul class="fontSize">
      <li>字體大小：</li>
      <li
        v-for="(item, index) in Fonts"
        :key="index"
        :class="item.current ? 'size current' : 'size'"
        @click="fontSizeClick(item)"
      >
        {{ item.txt }}
      </li>
    </ul>

    <p class="copy" id="loginData" v-if="LoginInfo">
      Hi, <span>{{LoginInfo.name}}</span>您好!!
      <input type="submit" class="btn" @click="logOut()" value="登出" />
    </p>

    <div class="menuBtn">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>

const vm = {
  name: "Logo",
  data() {
    return {
      Logo: "/PdpsCli/img/td_logo_in.png",
      LogoUrl: "",
      Fonts: [
        { txt: "大", class: "bodyBig", current: false },
        { txt: "中", class: "", current: true },
        { txt: "小", class: "bodySmall", current: false },
      ],
      fontSize: localStorage.getItem("fontSize") ? JSON.parse(localStorage.getItem("fontSize")) : null,
      LoginInfo: sessionStorage.getItem("LoginInfo") ? JSON.parse(sessionStorage.getItem("LoginInfo")) : ""
    };
  },
  props: ["parentData"],
  methods: {
    fontSizeClick: function (item) {
      //選擇的按鈕
      this.Fonts.forEach((x) => (x.current = false));
      item.current = true;
      localStorage.setItem('fontSize', JSON.stringify(this.Fonts));
      this.checkFontSize();
    },
    checkFontSize: function () {
      //body放大縮小
      let bodyElement = document.querySelector("body");
      bodyElement.classList = "";
      if(this.fontSize) this.Fonts = this.fontSize
      switch (this.Fonts.filter((x) => x.current)[0].class) {
        case "bodyBig":
          bodyElement.classList.add("bodyBig");
          break;
        case "bodySmall":
          bodyElement.classList.add("bodySmall");
          break;
      }
    },
    logOut: function(){
      switch (this.parentData.ServiceUnit) {
      case "CY":
        sessionStorage.removeItem("LoginInfo");
        sessionStorage.removeItem("Session_GovCode");
        localStorage.removeItem("fontSize");
        this.$router.push({path: '/BackStage/Cy/Login'});
        break;
      case "PDIS":
        sessionStorage.removeItem("LoginInfo");
        sessionStorage.removeItem("Session_GovCode");
        localStorage.removeItem("fontSize");
        this.$router.push({path: '/BackStage/PDIS/Login'});
        break;
      }
    }
  },
  created() {
    const self = this;
    let PicType = "";
    switch(window.location.host){
      case "pdps-bate.moj.gov.tw":
        PicType = "_ParallelTest";
        break;
    }
    switch (self.parentData.ServiceUnit) {
      case "CY":
        this.Logo = "/PdpsCli/img/td_logo_Cy"+PicType+"_0.png";
        this.LogoUrl = this.LoginInfo ?  "/PdpsCli/BackStage/CY/P102" : "/PdpsCli/BackStage/CY/Login";
        break;
      case "PDIS":
        this.Logo = "/PdpsCli/img/td_logo_Pdis"+PicType+".png";
        this.LogoUrl = this.LoginInfo ? "/PdpsCli/BackStage/PDIS/P102" : "/PdpsCli/BackStage/PDIS/Login";
        break;
      default:
        this.Logo = "/PdpsCli/img/td_logo_in"+PicType+".png";
        this.LogoUrl = "/PdpsCli/";
        break;
    }
    if(!self.LoginInfo && self.parentData.isForceLoginOut) this.logOut();
  },
  mounted() {
    this.checkFontSize();
    document.querySelector(".menuBtn").addEventListener("click", function () {
      document.querySelector("#menu").classList.toggle("menuShow");
    });
  },
};
export default vm;
</script>
